import React, { useContext, useEffect } from "react";
import RegistrationContext from "../../contexts/RegistrationContext";
import "./style.css";

function StatusBar({ noshow = false }) {
  const { error, setError, status, setStatus } =
    useContext(RegistrationContext);

  const handleCloseError = () => {
    setError(null);
  };
  const handleCloseStatus = () => {
    setStatus(null);
  };

  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => {
        setError(null);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [error]);

  useEffect(() => {
    if (status) {
      const timer = setTimeout(() => {
        setStatus(null);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [status]);

  return (
    <>
      <div
        className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50"
        style={{
          maxWidth: "500px",
          width: "90%",
        }}
      >

        {error && (
          <div
            className="w-full px-4 py-3 rounded relative text-center shadow-md"
            style={{ background: "#fff0f0", border: "1px solid #e08080", color: "#7a1a1a" }}
            role="alert"
          >
            <span className="block sm:inline">{error}</span>
            <span className="absolute top-0 bottom-0 right-0 px-4 py-3">
              <svg
                className="fill-current h-6 w-6 cursor-pointer"
              style={{ color: "#7a1a1a" }}
                onClick={handleCloseError}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <title>Close</title>
                <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" />
              </svg>
            </span>
          </div>
        )}
        {status && (
          <div
            className="ease-in-out w-full px-4 py-3 rounded relative shadow-md"
            style={{ background: "#EBFCFC", border: "1px solid #98e1ff", color: "#002E78" }}
            role="alert"
          >


            {status.split('\n').map((item, index) => (
              <div className="flex justify-center">
                <span key={index} className="block sm:inline">{item}</span>
              </div>
            ))}


            <span className="absolute top-0 bottom-0 right-0 px-4 py-3">
              <svg
                className="fill-current h-6 w-6 cursor-pointer"
              style={{ color: "#002E78" }}
                onClick={handleCloseStatus}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <title>Close</title>
                <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" />
              </svg>
            </span>
          </div>
        )}
      </div>
    </>
  );
}

export default StatusBar;
